import {FlaskConical, ShieldAlert} from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-center gap-2 mb-4">
          <FlaskConical className="h-6 w-6 text-emerald-500" aria-hidden="true" />
          <span className="text-lg font-bold text-white">BioSlick 实验计算站</span>
        </div>

        <div className="flex items-start gap-3 bg-slate-800/60 border border-slate-700 rounded-lg p-4 mb-6">
          <ShieldAlert className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
          <p className="text-sm text-slate-300">
            <strong className="text-white">Disclaimer:</strong>
            {' '}
            All calculators on BioSlick 实验计算站 are provided strictly for educational and modeling reference. Outputs must be independently verified before performing any biological laboratory procedure, clinical work, or regulated experiment.
          </p>
        </div>

        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} BioSlick 实验计算站. All calculations run locally in your browser; no laboratory data is transmitted or stored.
        </p>
      </div>
    </footer>
  )
}

export default Footer
